import { applyMiddleware, createStore, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import { save, load, combineLoads } from './redux-localstorage-simple'

import rootReducer from 'redux/reducers'
import { isBefore } from 'date-fns/esm'
import { addMonths } from 'date-fns'

export default function configureStore(preloadedState = {}) {
  const middlewares = [
    thunkMiddleware,
    save({
      ignoreStates: [
        'unsaved',
        'creditCards',
        'admins',
        'campaigns',
        'dashboard',
        'analytics',
        'admins',
        'editPlacements',
        'superAdmin'
      ]
    })
  ] // loggerMiddleware
  const middlewareEnhancer = composeWithDevTools(
    applyMiddleware(...middlewares)
  )

  const enhancers = [middlewareEnhancer]
  const composedEnhancers = compose(...enhancers)

  const store = createStore(
    rootReducer,
    combineLoads(
      load({
        initialValues: {
          values: [
            {
              key: 'newCampaign.startDate',
              value: isBefore(
                new Date(
                  JSON.parse(
                    localStorage.getItem('redux_localstorage_simple')
                  )?.newCampaign?.startDate
                ),
                new Date()
              )
                ? new Date()
                : new Date(
                    JSON.parse(
                      localStorage.getItem('redux_localstorage_simple')
                    )?.newCampaign?.startDate
                  )
            },
            {
              key: 'newCampaign.endDate',
              value: isBefore(
                new Date(
                  JSON.parse(
                    localStorage.getItem('redux_localstorage_simple')
                  )?.newCampaign?.startDate
                ),
                new Date()
              )
                ? addMonths(new Date(), 1)
                : new Date(
                    JSON.parse(
                      localStorage.getItem('redux_localstorage_simple')
                    )?.newCampaign?.endDate
                  )
            }
          ]
        }
      })
    ),
    composedEnhancers
  )

  return store
}
